<template>
  <div class="faqs" v-if="faqs">
    <FAQ v-for="faq in faqs" :key="faq.id" :q="faq.question" >
      <div v-html="faq.answer"></div>
    </FAQ>
  </div>
</template>

<script>
import axios from 'axios'

import FAQ from "@/components/FAQ.vue"

export default {
  name: "faqs",
  props: {
    site: String,
  },
  data: function() {
    return {
      faqs: null
    }
  },
  components: {
    FAQ
  },
  mounted: function() {
    axios.get(`/cms/api/v2/faqs/?site=${this.site}`)
      .then((response) => {
        this.faqs = response.data
      })
      .catch((err) => {
        console.log(err)
      })
  },
}
</script>
